const accounting = {
	title: 'Accounting',
	img: 'Accounting.png',
	courseAmt: 450,
	searchTerm: 'accounting',
};

const biology = {
	title: 'Biology',
	img: 'Biology.png',
	courseAmt: 500,
	searchTerm: 'biology',
};

const business = {
	title: 'Business',
	img: 'Business.png',
	courseAmt: 2000,
	searchTerm: 'business',
};

const computer = {
	title: 'Comp Sci',
	img: 'Computer Science.png',
	courseAmt: 500,
	searchTerm: 'computer science',
};

const criminology = {
	title: 'Criminology',
	img: 'Criminology.png',
	courseAmt: 500,
	searchTerm: 'criminology',
};

const economics = {
	title: 'Economics',
	img: 'Economics.png',
	courseAmt: 850,
	searchTerm: 'economics',
};

const education = {
	title: 'Education',
	img: 'Education.png',
	courseAmt: 500,
	searchTerm: 'education',
};

const engineering = { title: 'Engineering', courseAmt: 2622, searchTerm: 'engineering' };

const law = { title: 'Law', img: 'Law.png', courseAmt: 550, searchTerm: 'law' };

const medicine = {
	title: 'Medicine',
	img: 'Medicine.png',
	courseAmt: 75,
	searchTerm: 'medicine',
};

const nursing = {
	title: 'Nursing',
	img: 'Nursing.png',
	courseAmt: 275,
	searchTerm: 'nursing',
};

const politics = { title: 'Politics', courseAmt: 420, searchTerm: 'politics' };

const psychology = {
	title: 'Psychology',
	img: 'Psychology.png',
	courseAmt: 900,
	searchTerm: 'psychology',
};

const sports = {
	title: 'Sports Sci',
	img: 'Sports Science.png',
	courseAmt: 500,
	searchTerm: 'sport science',
};

const courseInfoTiles = [
	[law, psychology],
	[economics, business],
	[criminology, medicine],
	[biology, accounting],
];

const additionalTiles = [
	[computer, sports],
	[education, nursing],
];

const clearingTiles = [
	[psychology, law, business],
	[medicine, computer, nursing],
	[economics, biology, accounting],
	[education, politics, engineering],
];

const regularDescription =
	'Discover our most recommended universities that students are looking at the most. Find your perfect campus, order that next prospectus and immerse yourself in the university experience by connecting with one of our recommended universities. Compare our university opportunities.';
const clearingDescription = `Quickly discover available courses with our Clearing ${new Date().getFullYear()} Course Links. Easily access more info about entry requirements, course quality fees and funding, and university contact details.`;

export {
	courseInfoTiles,
	additionalTiles,
	clearingTiles,
	regularDescription,
	clearingDescription,
};
